import { Component } from '@angular/core';
import { FooterComponent } from '@coreui/angular';
import { environments } from 'src/environments/environments';

@Component({
    selector: 'app-admin-footer',
    templateUrl: './admin-footer.component.html',
    styleUrls: ['./admin-footer.component.scss'],
    standalone: true,
})
export class AdminFooterComponent extends FooterComponent {
  currentYear: number = new Date().getFullYear();
  developerUrl: string = environments.appUrls.developer;
  landingUrl: string = environments.appUrls.landing;

  constructor() {
    super();
  }
}
